// CustomDialog.js
import {
  Button,
  Dialog,
  DialogContent,
  InputLabel,
  Stack,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import React, { forwardRef, useImperativeHandle, useState } from "react";
import { APP_ICONS } from "../../assets";
import TextInput from "../../components/textInput";

// Styled Dialog
const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(5, 4),
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(4),
    },
  },
  "& .MuiPaper-root": {
    width: "550px",
    borderRadius: "20px",
    [theme.breakpoints.down("sm")]: {
      margin: 12,
    },
  },
}));

// Main Dialog Component
const CustomDialog = forwardRef(
  ({ handleCreate, inputValues, handleChange }, ref) => {
    const [open, setOpen] = useState(false);

    useImperativeHandle(ref, () => ({
      openDialog() {
        setOpen(true);
      },
      closeDialog() {
        setOpen(false);
      },
    }));

    const closeDialog = () => {
      setOpen(false);
    };

    return (
      <BootstrapDialog onClose={closeDialog} open={open}>
        <DialogContent>
          <Typography
            fontSize={"1.375rem"}
            fontWeight={600}
            textAlign={"center"}
            color={"primary.light"}
          >
            Create Category
          </Typography>

          <InputLabel>Category Title</InputLabel>
          <TextInput
            value={inputValues}
            onChange={(e) => handleChange(e.target.value)}
          />

          <Stack direction="row" alignItems="center" gap={1} mt={4}>
            <Button
              variant="custom_outlined"
              onClick={handleCreate}
              endIcon={
                <img
                  src={APP_ICONS.fileSaveIconBlue}
                  width={22}
                  alt="Save Icon"
                />
              }
            >
              Create
            </Button>
            <Button variant="suspend_button" onClick={closeDialog}>
              Discard
            </Button>
          </Stack>
        </DialogContent>
      </BootstrapDialog>
    );
  }
);

export default CustomDialog;
